<script>
  import NumberInput from './NumberInput2.svelte';

  let className = '';

  export {className as class};
  export let input = null;
  export let factor = 1;
  export let scale = 0;
  export let tickSizeEv = 1;
  export let precision = 1;
  export let valueEv = 0;
  export let disabled = false;
  export let placeholder = '';
  export let initText = '';
  export let isInline = true;
  export let operation = true;
  export let minValueEv = 0;
  export let maxValueEv = 0;
  export let showLabel = true;
  export let height = 38;
</script>

<NumberInput
  class={className}
  {isInline}
  {placeholder}
  {initText}
  {factor}
  {scale}
  {precision}
  {disabled}
  {operation}
  {showLabel}
  {height}
  minEx={minValueEv}
  maxEx={maxValueEv}
  tickSizeEx={tickSizeEv}
  bind:valueEx={valueEv}
  bind:input
  on:blur
  on:focus
  on:value-change
/>
